import React from 'react';
import { connect } from 'react-redux';

class SpecialItemSubmitButton extends React.Component {

    render() {
        return (
            <a
                onClick={this.props.onButtonPress}
            >
                <div className="special-button-window">
                    <div className="special-button-text-row">
                        <div className="special-button-text">DONE</div>
                        <div className="special-price">${this.props.price.toFixed(2)}</div>
                    </div>
                </div>
            </a>
        );
    }
};

export default connect()(SpecialItemSubmitButton);